import { OverLayContainer } from '@ulta/core/components/OverLayContainer/OverLayContainer';

export default OverLayContainer;